export const selectUserPrograms = (user) =>
  user.programs;
